module.exports = __webpack_public_path__ + "static/img/kefu.68ab010.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/kefu.jpg
// module id = 6Bs9
// module chunks = 1